/**
 * Highcharts implementation for annual reports 2019.
 */

import Highcharts from 'highcharts';

document.addEventListener("DOMContentLoaded", () => {

  Highcharts.setOptions({
    chart: {
      type: 'pie',
      style: {
        width: '100%'
      },
      height: 'auto',
      backgroundColor: 'transparent',
      plotShadow: false,
      plotBorderWidth: null
    },
    title: {
      'text': ''
    },
    colors: ['#265878', '#3C99D3', '#60C9D6', '#C3D93A', '#98A800', '#0599A8'],
    credits: {
      enabled: false
    },
    legend: {
      align: 'right',
      useHTML: true,
      labelFormat: '<div class="highcharts__legend"><span class="highcharts__legend-label">{name}</span> <span class="highcharts__legend-number">${y:,.0f}</span></div>',
      itemMarginTop: 10,
      layout: 'vertical',
      itemWidth: 500,
      symbolHeight: '14',
      symbolRadius: '0',
      itemStyle: {
        color: '#FFFFFF',
        fontSize: 14,
        fontWeight: 'normal',
      },
      title: {
        style: {
          color: '#60C9D6',
          fontWeight: 'bold',
          fontFamily: '"Futura", sans-serif',
          fontSize: '22px',
        },
      },
      verticalAlign: 'middle',
      itemHoverStyle: {
        color: 'lightgray'
      },
    },
    tooltip: {
      pointFormat: '{data.name} ${point.y:,.0f}'
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        borderWidth: 0,
        cursor: 'pointer',
        dataLabels: {
          enabled: false
        },
        showInLegend: true
      }
    },
    lang: {
      thousandsSep: ','
    },
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 800
          },
          chartOptions: {
            chart: {
              align: 'center',
              height: 400,
              marginBottom: 180,
              style: {
                width: '100%'
              },
            },
            legend: {
              useHTML: true,
              labelFormat: '<div class="highcharts__legend"><span class="highcharts__legend-label">{name}</span> <span class="highcharts__legend-number">${y:,.0f}</span></div>',
              width: '100%',
              align: 'center',
              verticalAlign: 'bottom',
              itemStyle: {
                textOverflow: undefined
              },
              itemWidth: undefined,
              maxHeight: 150
            }
          }
        },
        {
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            chart: {
              align: 'center',
              height: 400,
              marginBottom: 180,
              style: {
                width: '100%'
              },
            },
            legend: {
              useHTML: false,
              // labelFormat: '<div class="highcharts__legend"><span class="highcharts__legend-label">{name}</span> <span class="highcharts__legend-number">${y:,.0f}</span></div>',
              labelFormat: '<b>{name}</b> - ${y:,.0f}',
              width: '100%',
              align: 'center',
              verticalAlign: 'bottom',
              itemStyle: {
                textOverflow: undefined
              },
              itemWidth: undefined,
              maxHeight: 150
            }
          }
        },
      ],
    }
  });

  Highcharts.chart('income', {
    legend: {
      title: {
        text: 'Operating Income'
      }
    },
    series: [{
      name: 'Source',
      colorByPoint: true,
      data: [{
        name: 'Individual Donations',
        y: 11803547,
      }, {
        name: 'Corporate Support',
        y: 3877169
      }, {
        name: 'Foundation & Other Non-Profit',
        y: 2771553
      }, {
        name: 'Federal & CPB Community Service Grant',
        y: 1894913
      }, {
        name: 'Other Income',
        y: 1158264
      }, {
        name: 'Local & State Government',
        y: 196247
      }]
    }]
  });

  Highcharts.chart('expenses', {
    legend: {
      title: {
        text: 'Operating Functional Expenses'
      }
    },
    series: [{
      name: 'Source',
      colorByPoint: true,
      data: [{
        name: 'Program Services',
        y: 10826478,
      }, {
        name: 'Development, Membership, and Marketing',
        y: 4773835
      }, {
        name: 'General and Administrative',
        y: 2929867
      }]
    }]
  });
});


